// src/context/AdminContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

const AdminContext = createContext({ promoText: "", bannerText: "" });

export function AdminProvider({ children }) {
  const [promoText, setPromoText] = useState("");
  const [bannerText, setBannerText] = useState("");

  useEffect(() => {
    // Listen to EXACTLY the same doc Admin.jsx writes to
    const ref = doc(db, "siteConfig", "global");
    const unsub = onSnapshot(
      ref,
      (snap) => {
        const data = snap.data() || {};
        setPromoText(data.promoText || "");
        setBannerText(data.bannerText || "");
      },
      (err) => {
        console.error("AdminProvider onSnapshot error:", err);
      }
    );
    return () => unsub();
  }, []);

  return (
    <AdminContext.Provider value={{ promoText, bannerText }}>
      {children}
    </AdminContext.Provider>
  );
}

export function useAdmin() {
  return useContext(AdminContext);
}
